import React, {useState} from 'react';

export default function InstallerListing(props) {

    const name = props.installer.name;
    const accountId = props.installer.accountID;
    const installerJobs = props.installerJobs[accountId];
    const selectedDate = props.selectedDate;
    const [selectedVehicle, setSelectedVehicle] = useState(null);

    const handleVehicleChange = (event) => {
        setSelectedVehicle(event.target.value);
    };

    const handleInstallerCalendarOpen = () => {
        if (selectedVehicle) {
            props.onInstallerSelection(accountId, selectedVehicle, selectedDate, name, props.job);
        }
    };

    
    return (
        <div className='installer-container'>
            <div className="installer-profile">

                <div className="col">
                    <img src={require('../../../testing/mockdata/InstallerImages/' + props.installer.profilePicture)}
                         alt="installer ID"/>
                </div>
                <div className="installer-info">

                    <table className="table table-borderless">
                        <tbody>
                        <tr>
                            <th scope="row">Name:</th>
                            <td>{props.installer.name}</td>
                        </tr>
                        <tr>
                            <th scope="row">Skillset:</th>
                            <td>{props.installer.skillSet.charAt(0).toUpperCase() + props.installer.skillSet.substr(1).toLowerCase()}</td>
                        </tr>
                        <tr>
                            <th scope="row">Hours (per week):</th>
                            <td>{props.installer.hours}</td>
                        </tr>
                        <tr>
                            <th scope="row">Total jobs today:</th>
                            <td>{installerJobs}</td>
                        </tr>
                        </tbody>
                    </table>

                </div>

            </div>

            <div className="btn-col d-grid">

                <div className="btn-group">
                    <select value={selectedVehicle || ''} className="btn btn-secondary" onChange={handleVehicleChange}>
                        <option value='' disabled>Select vehicle to assign...</option>


                        {props.vehicleList && props.vehicleList.map((vehicle, index) => (
                            <option key={index} value={vehicle.VehicleID}>
                                {`Vehicle ${vehicle.VehicleID}: ${vehicle.Make} ${vehicle.Model}`}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="btn-group">
                    {selectedVehicle &&
                        <button className="btn btn-secondary" onClick={handleInstallerCalendarOpen}>Open Installer
                            Calendar</button>}
                </div>

            </div>
        </div>

    );

}
